import { useIntakeForm } from "../../../useIntakeForm.js";
import type { ClientPortalApiClient } from "../../../api.js";

export function useV10IntakeForm({
  api,
  linkId,
  sessionToken,
  linkStatus,
  onStatus,
}: {
  readonly api: ClientPortalApiClient;
  readonly linkId: string;
  readonly sessionToken: string;
  readonly linkStatus: string;
  readonly onStatus: (message: string | null) => void;
}) {
  return useIntakeForm({
    api,
    clientLinkId: linkId,
    token: sessionToken,
    linkStatus,
    onStatus,
  });
}
